import { render, staticRenderFns } from "./DisclosureParticipantsTab.vue?vue&type=template&id=0ac349a7"
import script from "./DisclosureParticipantsTab.vue?vue&type=script&lang=js"
export * from "./DisclosureParticipantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports